import React from 'react';
import { useSelector } from 'react-redux';
import { selectSpecificationComponentsCategory } from 'store/specificationComponentsSlice';
import CategoriesList from './CategoriesList';
import Components from './Components';
import styles from './ModalContent.module.scss';
import ProductParameterFiltersPanel from './ProductParameterFiltersPanel';
function ModalContent({ modalView }) {
    const selectedCategory = useSelector(selectSpecificationComponentsCategory);
    const shouldShowFilters = modalView === 'components' && Boolean(selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.filtersAvailable);
    return (React.createElement("div", { className: styles.layout },
        React.createElement("aside", { className: styles.sidebar },
            React.createElement(CategoriesList, null)),
        shouldShowFilters && React.createElement(ProductParameterFiltersPanel, null),
        React.createElement("div", { id: "modal-content-component-list", className: styles.content }, modalView === 'components' && React.createElement(Components, null))));
}
export default ModalContent;
